module.exports = __webpack_public_path__ + "static/media/loader.268463b4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loader.svg
// module id = 1021
// module chunks = 0